import { Cell } from '../../../../components/common/table/Cell/Cell';
import { Row } from '../../../../components/common/table/Row/Row';
import { InfusionSession } from '../PatientInfusion';
import { intervalToDuration } from 'date-fns';
import './InfusionHistoryRow.scss';
import { useEffect, useState } from 'react';
import { convertDate, convertTime } from 'src/components/common/convertDateTime/convertDateTime';

export interface InfusionHistoryRowProps {
  session: InfusionSession;
  index: number;
}

export const InfusionHistoryRow = ({ session, index }: InfusionHistoryRowProps) => {
  const [sessionStatus, setSessionStatus] = useState<string>('N/A');

  const getDuration = (startDateTime: string, endDateTime: string) => {
    const duration = intervalToDuration({
      start: new Date(startDateTime),
      end: new Date(endDateTime),
    });
    let res = '';
    if (duration.hours) res += `${duration.hours} ${duration.hours === 1 ? 'Hour' : 'Hours'}${(duration.minutes || duration.seconds) && ', '} `;
    if (duration.minutes) res += `${duration.minutes} ${duration.minutes === 1 ? 'Minute' : 'Minutes'} `;
    if (duration.seconds && !duration.minutes) res += `${duration.seconds} ${duration.seconds === 1 ? 'Second' : 'Seconds'}`;
    return res;
  };

  useEffect(() => {
    if (session?.body?.status && session.body.status === 'INFUSION_STATUS_COMPLETED') {
      setSessionStatus('COMPLETED');
    } else if (session?.body?.status && session.body.status === 'INFUSION_STATUS_ACTIVE') {
      setSessionStatus('ACTIVE');
    }
  }, [session]);

  return (
    <Row index={index} key={session._id} classes={'infusion-history-row-container'}>
      <Cell>{sessionStatus || 'N/A'}</Cell>
      <Cell>{convertDate(session?.body?.beg_date_time_utc)}</Cell>
      <Cell>{convertTime(session?.body?.beg_date_time_utc)}</Cell>
      <Cell>{convertTime(session?.body?.end_date_time_utc)}</Cell>
      <Cell>{session?.body?.end_date_time_utc && getDuration(session?.body?.beg_date_time_utc, session?.body?.beg_date_time_utc)}</Cell>
      <Cell>{session?.header?.user?.name}</Cell>
    </Row>
  );
};
